import React from "react";
import { InputLabel } from "@material-ui/core";
import clsx from "clsx";

import useStyles from "./FieldLabel.style";

type FieldLabelPropsBase = {
  children: React.ReactNode;
  testId?: string;
  disabled?: boolean;
  className?: string;
};

type FieldLabelPropsWithId = FieldLabelPropsBase & { id: string; htmlFor?: string };
type FieldLabelPropsWithHtmlFor = FieldLabelPropsBase & { htmlFor: string; id?: string };
type FieldLabelPropsWithBoth = FieldLabelPropsBase & { id: string; htmlFor: string };

type FieldLabelProps = FieldLabelPropsWithId | FieldLabelPropsWithHtmlFor | FieldLabelPropsWithBoth;

export const FieldLabel = ({
  children,
  id,
  testId = "FieldLabel",
  htmlFor,
  className,
  }: FieldLabelProps) => {
  const c = useStyles({});
  return (
    <InputLabel htmlFor={htmlFor} className={clsx(c.root, className)} data-testid={testId} id={id}>
      {children}
    </InputLabel>
  );
};
